var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubble2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_2766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0031 11.3929C10.7861 11.3929 10.6102 11.217 10.6102 11C10.6102 10.783 10.7861 10.6071 11.0031 10.6071",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0031 11.3929C11.22 11.3929 11.3959 11.217 11.3959 11C11.3959 10.783 11.22 10.6071 11.0031 10.6071",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68161 11.3929C6.46465 11.3929 6.28876 11.217 6.28876 11C6.28876 10.783 6.46465 10.6071 6.68161 10.6071",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68161 11.3929C6.89858 11.3929 7.07447 11.217 7.07447 11C7.07447 10.783 6.89858 10.6071 6.68161 10.6071",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3245 11.3929C15.1075 11.3929 14.9316 11.217 14.9316 11C14.9316 10.783 15.1075 10.6071 15.3245 10.6071",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3245 11.3929C15.5414 11.3929 15.7174 11.217 15.7174 11C15.7174 10.783 15.5414 10.6071 15.3245 10.6071",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9971 0.880861C9.16665 0.881432 7.37063 1.37848 5.80033 2.31907C4.23005 3.25966 2.94429 4.60856 2.08001 6.2221C1.21572 7.83565 0.805278 9.65341 0.892395 11.4818C0.97951 13.3101 1.56092 15.0806 2.57471 16.6047L0.877777 21.1195L6.56015 20.092C7.92846 20.7606 9.43002 21.1118 10.9529 21.1194C12.4759 21.1269 13.9808 20.7906 15.3557 20.1355C16.7305 19.4805 17.9399 18.5235 18.8933 17.336C19.8468 16.1486 20.5202 14.7612 20.8627 13.2773C21.2055 11.7935 21.2089 10.2514 20.8726 8.76603C20.5364 7.28066 19.8693 5.89036 18.9209 4.69874C17.9726 3.50711 16.7674 2.54493 15.3955 1.88388C14.0235 1.22282 12.52 0.879962 10.9971 0.880861Z",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_2766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble2);
export default __webpack_public_path__ + "static/media/chat-bubble-2.97a3ecd2b93997505c8b72b2db40d474.svg";
export { ForwardRef as ReactComponent };